import { StepperVariant } from '../types/stepper';
import {
  CreditApplicationStatusType,
  CreditConfig,
  billingDetailsFormSchema,
  companyDetailsFormSchema,
  insuranceDetailsFormSchema,
} from '../types/credit';

export const creditConfig: CreditConfig = {
  stepperConfig: {
    companyDetails: {
      showInStepper: true,
      stepLabel: 'Company Details',
      backLabel: 'company info',
      fields: [...Object.keys(companyDetailsFormSchema.shape).map((e) => 'companyDetails.' + e)],
    },
    billingDetails: {
      showInStepper: true,
      stepLabel: 'Billing Details',
      backLabel: 'billing info',
      fields: [...Object.keys(billingDetailsFormSchema.shape).map((e) => 'billingDetails.' + e)],
    },
    insuranceDetails: {
      showInStepper: true,
      stepLabel: 'Insurance Details',
      backLabel: 'insurance info',
      fields: [
        ...Object.keys(insuranceDetailsFormSchema._def.schema.shape).map(
          (e) => 'insuranceDetails.' + e,
        ),
      ],
    },
    review: {
      showInStepper: StepperVariant.BAR,
      stepLabel: 'Review',
    },
  },
  stepperOrder: ['companyDetails', 'billingDetails', 'insuranceDetails', 'review'],
  stepperStatus: [
    CreditApplicationStatusType.STEP1_SAVED,
    CreditApplicationStatusType.STEP2_SAVED,
    CreditApplicationStatusType.STEP3_SAVED,
    CreditApplicationStatusType.SUBMITTED,
  ],
};

export const START_CREDIT_SUMMARY_ANIMATION = 'start-checkout-header-animation';

export const END_CREDIT_SUMMARY_ANIMATION = 'end-checkout-header-animation';

export enum ErrorCodes {
  FORM_ALREADY_SUBMITTED = 'FORM_ALREADY_SUBMITTED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  INVALID_REQUEST = 'INVALID_REQUEST',
  BLOCKED_REQUEST = 'BLOCKED_REQUEST',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  VERIFICATION_FAILED = 'VERIFICATION_FAILED',
  SYSTEM_FAILURE = 'SYSTEM_FAILURE',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  CREDIT_LIMIT_ALREADY_SET = 'CREDIT_LIMIT_ALREADY_SET',
}

export const creditApplicationImage =
  'https://uploads-ssl.webflow.com/60cb2013a506c737cfeddf74/658d92f438cd3aca06511ed0_credit_application_image.png';
